<script setup>
import ImpactsImage from "@/components/impact/ImpactsImage.vue";
</script>

<template>
  <div class="heading1 !mb-2">
    The Quantum wall
    <hr class="gradientLine" />
  </div>
  <p class="pt-8">
    The Quantum Wall Project aims to visualize and communicate the societal
    impacts of quantum technology on a global scale. Through an interactive
    website and <strong>AI tools</strong>, the project aims to engage the
    public, policymakers, and stakeholders across various sectors, highlighting
    the
    <strong> transformative potential of quantum technologies. </strong>
  </p>

  <div class="flex flex-col items-center my-8">
    <img src="/qwallTimeline.png" alt="" />
  </div>
  <section class="mt-12 bg-slate-100 k1:p-8 p-4">
    <h2 class="gradientText text-2xl leading-none mb-4 font-bold w-fit">
      Objectives
    </h2>
    <ul class="grid h8:grid-cols-3 gap-8">
      <li class="bg-white shadow-slate-100 shadow-xl p-5">
        <span
          class="text-center leading-none font-bold gradientText w-fit block"
        >
          Quantum Visionary
        </span>
        To create an impact-focused interactive online platform showcasing how
        quantum technology can revolutionize domains such as healthcare,
        renewable energy, security, finance, and more.
      </li>
      <li class="bg-white shadow-slate-100 shadow-xl p-5">
        <span
          class="text-center leading-none font-bold gradientText w-fit block"
        >
          Impact Catalyst
        </span>
        To facilitate public engagement and awareness of quantum technology’s
        benefits and applications through advanced data analysis and interactive
        tools.
      </li>
      <li class="bg-white shadow-slate-100 shadow-xl p-5">
        <span
          class="text-center leading-none font-bold gradientText w-fit block"
        >
          Future Frame
        </span>
        To create and disseminate compelling AI generated images, that easily
        illustrate the real-world impact of EU quantum projects.
      </li>
    </ul>
  </section>
  <ImpactsImage />
  <p>
    Overall, the Quantum Wall Project stands as a pioneering effort to bridge
    the gap between the complex world of quantum technology and the public.
    Through <strong> interactive and visual means</strong>, it endeavors to
    enlighten, engage, and inspire a wide audience about the future
    possibilities that quantum technology holds for society, bolstered by
    innovative AI applications and a comprehensive global perspective.
  </p>
</template>

<style scoped></style>
